import React from "react";

const Loading = () => {

    return <div className={"tms-is-loading"}>
        Bitte einen Moment Geduld ....
    </div>;
};
export default Loading;
